// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchHistoryStyles, SearchHistoryStyles } from "@guestsupply/Overrides/Widgets/Header/SearchHistory";
import { xScreen } from "@guestsupply/XDL/Utilities";
import Clock from "@insite/mobius/Icons/Clock";
import { css } from "styled-components";

const searchHistoryStylesExtensions: SearchHistoryStyles = {
    headerText: {
        weight: "bold",
        css: css`
            text-align: left;
            margin: 10px 0 5px 0;
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 250px;
            padding: 0 20px 15px 20px;
            width: ${({ width }: any) => width}px;
            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
    },
    itemWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    icon: {
        src: Clock,
        css: css`
            margin-right: 10px;
        `,
    },
    link: {
        typographyProps: {
            ellipsis: true,
            css: css`
                width: 100%;
                text-align: left;
                margin: 5px 0;
            `,
        },
        css: css`
            width: 100%;
            overflow: hidden;
        `,
    },
    focusedLink: {
        typographyProps: {
            ellipsis: true,
            css: css`
                width: 100%;
                text-align: left;
                margin: 5px 0;
            `,
        },
        css: css`
            width: 100%;
            overflow: hidden;
            background-color: lightgray;
        `,
    },
    clearLink: {
        typographyProps: {
            css: css`
                width: 100%;
                text-align: right;
                margin-top: 10px;
            `,
        },
    },
};

searchHistoryStyles.headerText = searchHistoryStylesExtensions.headerText;
searchHistoryStyles.wrapper = searchHistoryStylesExtensions.wrapper;
searchHistoryStyles.itemWrapper = searchHistoryStylesExtensions.itemWrapper;
searchHistoryStyles.icon = searchHistoryStylesExtensions.icon;
searchHistoryStyles.link = searchHistoryStylesExtensions.link;
searchHistoryStyles.focusedLink = searchHistoryStylesExtensions.focusedLink;
searchHistoryStyles.clearLink = searchHistoryStylesExtensions.clearLink;
